var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15002_47376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.08398V4.87564L7.58333 3.79231",
    stroke: "#D08759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5013 4.87436L5.41797 3.79102",
    stroke: "#D08759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07422 7.04102H3.46297C3.6688 7.04102 3.85297 7.15477 3.94505 7.33894L4.5788 8.60644C4.76297 8.97477 5.13672 9.20769 5.54839 9.20769H7.46047C7.87214 9.20769 8.24588 8.97477 8.43005 8.60644L9.0638 7.33894C9.15588 7.15477 9.34547 7.04102 9.54589 7.04102H11.9076",
    stroke: "#D08759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79036 2.23633C1.87286 2.518 1.08203 3.64467 1.08203 5.95758V8.12425C1.08203 10.8326 2.16536 11.9159 4.8737 11.9159H8.1237C10.832 11.9159 11.9154 10.8326 11.9154 8.12425V5.95758C11.9154 3.64467 11.1245 2.518 9.20703 2.23633",
    stroke: "#D08759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15002_47376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteRequest);
export default __webpack_public_path__ + "static/media/websiteRequest.f8085ef313c73f8cf0e691fafd1b3f96.svg";
export { ForwardRef as ReactComponent };